import { render, staticRenderFns } from "./UserPreferencesElement.vue?vue&type=template&id=11791be0&scoped=true"
import script from "./UserPreferencesElement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPreferencesElement.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserPreferencesElement.vue?vue&type=style&index=0&id=11791be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11791be0",
  null
  
)

export default component.exports